type AnyObject = { [prop: string]: any };

export const removeEmptyValuesFromObject = <T extends AnyObject>(o: T): T => {
  const object = { ...o };
  Object.keys(object).forEach((key) => {
    object[key] === undefined && delete object[key];
  });
  return object;
};

export const removeEmptyValuesFromObjectDeep = <T extends {}>(o: T): T => {
  const object = { ...o } as Record<string, any>;
  Object.keys(object).forEach((key) => {
    if (typeof object[key] === 'object' && object[key] !== null) {
      object[key] = removeEmptyValuesFromObjectDeep(object[key]);
    }
    if (object[key] === undefined || object[key] === '') {
      delete object[key];
    }
  });
  return object as T;
};
